import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, BehaviorSubject } from 'rxjs';

import { AuthorizationService } from './authorization.service';

@Injectable()
export class AuthGuard implements CanActivate {
  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }
  constructor(private router: Router, public authService: AuthorizationService, private cookieService: CookieService) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    if (sessionStorage.getItem('usertoken') != null) {
      // if (this.cookieService.get('usertoken') != null) {
      this.loggedIn.next(true);
      // this.authService.loggedIn.next(true);
      this.authService.loggedIn = true;
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}

